/* RESPONSIBLE TEAM: team-inbox-management */
import ApplicationAdapter from './application';

export default class CopilotSettingsAdapter extends ApplicationAdapter {
  pathForType() {
    return 'inbox/copilot_settings';
  }

  urlForFindRecord() {
    return `/ember/inbox/copilot_settings`;
  }

  urlForUpdateRecord() {
    return `/ember/inbox/copilot_settings`;
  }
}
